
































































































































import Vue from 'vue';

import ColorPicker from '@/components/ColorPicker.vue';
import PreviewTitle from '@/components/PreviewTitle.vue';

export default Vue.extend({
    components: {
        ColorPicker,
        PreviewTitle,
    },
    props: {
        shades: {
            type: Object as () => ColorShades,
            required: true,
        },
    },
    data: () => ({
        buttonHovered: false,
    }),
    computed: {
        hasStandardShades(): boolean {
            return '100' in this.shades
                && '200' in this.shades
                && '300' in this.shades
                && '400' in this.shades
                && '500' in this.shades
                && '600' in this.shades
                && '700' in this.shades
                && '800' in this.shades
                && '900' in this.shades;
        },
    },
});
